import { BehaviorSubject } from 'rxjs';
import { IntlShape } from 'react-intl';
import { MessageModalData } from '../types/message';

export const isMessageModalOpen = new BehaviorSubject<MessageModalData | null>(null);

export const openMessageModal = (data: MessageModalData) => {
  if (!isMessageModalOpen.getValue()) {
    isMessageModalOpen.next({ ...data });
  }
};

export const closeMessageModal = () => {
  isMessageModalOpen.next(null);
};

// Utility function to format messages using react-intl
// This function takes an IntlShape instance and a message object,
// and returns a new object with the messages formatted.
export const intlMessageObject = (
  intl: IntlShape,
  messageObj: Record<string, string>,
): Record<string, string> => {
  const result: Record<string, string> = {};

  for (const key in messageObj) {
    result[key] = intl.formatMessage({ id: messageObj[key] });
  }
  return result;
};
